import React, { useState, useEffect } from "react";
import { Col, Button, Row, Block } from "framework7-react";
import { setLiteral } from "../../../js/helpers";
import { jsPDF } from "jspdf";
const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
};
const formatCurrency = (value) => {
  if (isNaN(value) || value === null) return "0.00";
  return (
    "$ " +
    new Intl.NumberFormat("es-ES", { minimumFractionDigits: 2 }).format(value)
  );
};

const AmortizationTable = ({ installments, lsLiterales }) => {
  const [uniqueData, setUniqueData] = useState([]);

  const generatePDF = (data) => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const columns = [
      { header: setLiteral(lsLiterales, 102040), dataKey: "number" },
      { header: setLiteral(lsLiterales, 102041), dataKey: "expected_date" },
      { header: setLiteral(lsLiterales, 102042), dataKey: "capital_repayment" },
      {
        header: setLiteral(lsLiterales, 102043),
        dataKey: "interest_repayment",
      },
      {
        header: setLiteral(lsLiterales, 102100),
        dataKey: "unpaid_interest_tax",
      },
      { header: setLiteral(lsLiterales, 102044), dataKey: "commission" },
      { header: setLiteral(lsLiterales, 102104), dataKey: "IM" },
      { header: setLiteral(lsLiterales, 102045), dataKey: "fees_unpaid" },
      { header: setLiteral(lsLiterales, 102101), dataKey: "unpaid_insurance" },
      { header: setLiteral(lsLiterales, 102046), dataKey: "total" },
      { header: setLiteral(lsLiterales, 102047), dataKey: "paid_capital" },
      { header: setLiteral(lsLiterales, 102048), dataKey: "paid_interest" },
      { header: setLiteral(lsLiterales, 102102), dataKey: "paid_interest_tax" },
      { header: setLiteral(lsLiterales, 102049), dataKey: "paid_commission" },
      { header: setLiteral(lsLiterales, 102105), dataKey: "IMP" },
      { header: setLiteral(lsLiterales, 102050), dataKey: "paid_fees" },
      { header: setLiteral(lsLiterales, 102103), dataKey: "paid_insurance" },
      { header: setLiteral(lsLiterales, 102046), dataKey: "CUOTA" },
      { header: setLiteral(lsLiterales, 102051), dataKey: "paid_date" },
    ];

    const uniqueRows = new Set();
    const uniqueData = data.filter((item) => {
      const rowString = JSON.stringify(item);
      if (uniqueRows.has(rowString)) {
        return false;
      }
      uniqueRows.add(rowString);
      return true;
    });

    const rows = uniqueData.map((item) => ({
      number: item.number.toString(),
      expected_date: formatDate(item.expected_date),
      capital_repayment: formatCurrency(item.capital_repayment),
      interest_repayment: formatCurrency(item.interest_repayment),
      unpaid_interest_tax: formatCurrency(item.unpaid_interest_tax),
      commission: formatCurrency(item.commission),
      IM: formatCurrency(
        parseFloat(item.penalty_interest) +
          parseFloat(item.penalty_interest_tax)
      ),
      fees_unpaid: formatCurrency(item.fees_unpaid),
      unpaid_insurance: formatCurrency(item.unpaid_insurance),
      total: formatCurrency(item.total),
      paid_capital: formatCurrency(item.paid_capital),
      paid_interest: formatCurrency(item.paid_interest),
      paid_interest_tax: formatCurrency(item.paid_interest_tax),
      paid_commission: formatCurrency(item.paid_commission),
      IMP: formatCurrency(
        parseFloat(item.paid_penalty_interest) +
          parseFloat(item.paid_penalty_interest_tax)
      ),
      paid_fees: formatCurrency(item.paid_fees),
      paid_insurance: formatCurrency(item.paid_insurance),
      CUOTA: formatCurrency(
        parseFloat(item.paid_capital) +
          parseFloat(item.paid_interest) +
          parseFloat(item.paid_commission) +
          parseFloat(item.paid_fees) +
          parseFloat(item.paid_interest_tax) +
          parseFloat(item.paid_insurance)
      ),
      paid_date: formatDate(item.paid_date),
    }));

    doc.setFontSize(12);
    doc.text("Tabla de Amortización", 14, 15);

    doc.autoTable({
      startY: 25,
      head: [columns.map((col) => col.header)],
      body: rows.map((row) => columns.map((col) => row[col.dataKey])),
      theme: "striped",
      styles: {
        fontSize: 6,
        cellPadding: 1,
        overflow: "linebreak",
        halign: "center",
      },
      headStyles: {
        fillColor: [0, 72, 135],
        textColor: [255, 255, 255],
        halign: "center",
        fontSize: 5,
      },
      columnStyles: {
        0: { halign: "center" },
        1: { halign: "center" },
        2: { halign: "center" },
        3: { halign: "center" },
        4: { halign: "center" },
        5: { halign: "center" },
        6: { halign: "center" },
        7: { halign: "center" },
        8: { halign: "center" },
        9: { halign: "center" },
        10: { halign: "center" },
        18: { halign: "center" },
      },
      margin: { top: 25 },
      tableWidth: "auto",
    });

    doc.save("tabla.pdf");
  };

  const renderAmortizationTable = (installments) => {
    if (installments === undefined) {
    } else {
      const uniqueRows = new Set();
      const uniqueDataLoad = installments.filter((item) => {
        const rowString = JSON.stringify(item);
        if (uniqueRows.has(rowString)) {
        }
        uniqueRows.add(rowString);
      });

      if (installments.length > 0) {
        return (
          <div
            id="blInstallments"
            width="100"
            xlarge="100"
            large="100"
            small="100"
            xsmall="100"
            style={{ width: "100%" }}
          >
            <Row>
              <Col className="center large">
                {setLiteral(lsLiterales, 102040)}
              </Col>
              <Col className="center large">
                {setLiteral(lsLiterales, 102041)}
              </Col>
              <Col className="center large">
                {setLiteral(lsLiterales, 102042)}
              </Col>
              <Col className="center large">
                {setLiteral(lsLiterales, 102043)}
              </Col>
              <Col className="center large">
                {setLiteral(lsLiterales, 102100)}
              </Col>
              <Col className="center large">
                {setLiteral(lsLiterales, 102044)}
              </Col>
              <Col className="center large">
                {setLiteral(lsLiterales, 102104)}
              </Col>
              <Col className="center large">
                {setLiteral(lsLiterales, 102045)}
              </Col>
              <Col className="center large">
                {setLiteral(lsLiterales, 102101)}
              </Col>
              <Col className="center large">
                {setLiteral(lsLiterales, 102046)}
              </Col>
              <Col className="center large">
                {setLiteral(lsLiterales, 102051)}
              </Col>
            </Row>
            {installments.map((item) => (
              <Row id={"row" + item.number.toString()} className="itemTable">
                <Col className="light center" style={{ textAlign: "center" }}>
                  {item.number.toString()}
                </Col>
                <Col className="light center" style={{ textAlign: "center" }}>
                  {formatDate(item.expected_date)}
                </Col>
                <Col className="light center" style={{ textAlign: "right" }}>
                  {formatCurrency(item.capital_repayment)}
                </Col>
                <Col className="light center" style={{ textAlign: "right" }}>
                  {formatCurrency(item.interest_repayment.toString())}
                </Col>
                <Col className="light center" style={{ textAlign: "right" }}>
                  {formatCurrency(item.unpaid_interest_tax.toString())}
                </Col>
                <Col className="light center" style={{ textAlign: "right" }}>
                  {formatCurrency(item.commission.toString())}
                </Col>
                <Col className="light center" style={{ textAlign: "right" }}>
                  {formatCurrency(
                    parseFloat(item.paid_penalty_interest) +
                      parseFloat(item.paid_penalty_interest_tax)
                  )}
                </Col>
                <Col className="light center" style={{ textAlign: "right" }}>
                  {formatCurrency(item.fees_unpaid.toString())}
                </Col>
                <Col className="light center" style={{ textAlign: "right" }}>
                  {formatCurrency(item.unpaid_insurance.toString())}
                </Col>
                <Col className="light center" style={{ textAlign: "right" }}>
                  {formatCurrency(item.cuota.toString())}
                </Col>
                <Col className="light center" style={{ textAlign: "center" }}>
                  {formatDate(item.paid_date)}
                </Col>
              </Row>
            ))}
            <br></br>
          </div>
        );
      }
    }
  };

  return (
    <Block>
      <Row
        id="rowInstallments"
        width="100"
        xlarge="100"
        large="100"
        small="100"
        xsmall="100"
      >
        {renderAmortizationTable(installments)}
      </Row>
      <Row>
        <Col width="100%" className="aligner3 right">
          <Button
            id="btnDownloadPdf"
            style={{ width: "400px" }}
            className="linkButton smaller light"
            onClick={() => generatePDF(installments)}
          >
            {/* {setLiteral(lsLiterales, 102145)} › */}
            DESCARGAR CUADRO
          </Button>
        </Col>
      </Row>
    </Block>
  );
};

export default AmortizationTable;
